export default __webpack_public_path__ + "static/media/nut-2.d846948f.svg";